function insort(a, o, k) {
  let left = 0, right = a.length, ok = k(o)
  while (left < right) {
    const c = Math.floor((left + right) / 2),
      ck = k(a[c])
    if (ok < ck)
      right = c
    else
      left = c + 1
  }
  a.splice(left, 0, o)
  return left
}

export default function Coords() {
  
  let lats = []
  let lngs = []

  this.north = null
  this.east = null
  this.south = null
  this.west = null

  const checkAdd = (c) => {
    if (c._lati === 0)
      this.south = c.lat
    if (c._lati === lats.length - 1)
      this.north = c.lat
    if (c._lngi === 0)
      this.west = c.lng
    if (c._lngi === lngs.length - 1)
      this.east = c.lng
  }

  const checkRemove = (c) => {
    if (lats.length >= 2) {

      if (c._lati === 0)
        this.south = lats[1].lat
      else if (c._lati === lats.length - 1)
        this.north = lats[lats.length - 2].lat

      if (c._lngi === 0)
        this.west = lngs[1].lng
      else if (c._lngi === lngs.length - 1)
        this.east = lngs[lngs.length - 2].lng

    } else {

      this.north = this.east = this.south = this.west = null

    }
  }

  const add = (c) => {
    c._lat = c.lat
    c._lng = c.lng
    c._lati = insort(lats, c, c => c._lat)
    c._lngi = insort(lngs, c, c => c._lng)
    for (let i=c._lati+1; i<lats.length; i++)
      lats[i]._lati = i
    for (let i=c._lngi+1; i<lngs.length; i++)
      lngs[i]._lngi = i
    checkAdd(c)
  }

  const dump = () => {
    //console.log(this.north, this.east, this.south, this.west)
    //console.log(lats.length, lngs.length)
    //for (let i=0; i<lats.length; i++)
    //  console.log(`[${i}]: ${lats[i].lat}`)
  }

  this.create = (lat, lng) => {
    let c = { lat, lng }
    add(c)
    dump()
    return c
  }

  this.remove = (c) => {
    checkRemove(c)
    lats.splice(c._lati, 1)
    lngs.splice(c._lngi, 1)
    for (let i=c._lati; i<lats.length; i++)
      lats[i]._lati = i
    for (let i=c._lngi; i<lngs.length; i++)
      lngs[i]._lngi = i
    dump()
  }

  this.update = (c) => {
    this.remove(c)
    add(c)
    dump()
  }

}

